export function formatCurrencyCodeForRegion(region: string): string {
  return `${region}`;
}
